export enum ActivityType {
    Call = "call",
    Email = "email",
    Meeting = "meeting",
    Note = "note",
    Task = "task",
    WhatsApp = "whatsapp",
    LinkedIn = "linkedin",
    ConnectionRequest = "connection request",
    InMail = "inmail",
    ProfileView = "profile view",
}

export enum ActivityDirection {
    Inbound = "inbound",
    Outbound = "outbound",
}

export enum ActivityOutcome {
    Connected = "connected",
    NoAnswer = "no answer",
    Voicemail = "voicemail",
    FollowUpNeeded = "follow-up needed",
    Successful = "successful",
}

/** One person an activity was with — an outside contact or one of our staff. Saves read only `userDetailId`. */
export type ActivityParticipant = {
    userDetailId: number;
    fullName?: string | null;
    organizationName?: string | null;
    /** Works at one of our own companies. */
    isStaff?: boolean;
};

/**
 * One person the "With" picker offers (`activities/people`): the record's own
 * people, our team, or someone else found by name.
 */
export type ActivityPerson = {
    userDetailId: number;
    fullName: string;
    position: string | null;
    organizationId: number | null;
    organizationName: string | null;
    phone: string | null;
    email: string | null;
    group: "record" | "team" | "other";
};

export type ActivityItem = {
    activityId: number | null;
    parentType: string;
    parentId: number;
    /** The people it was with. Left out of a save = keep the current ones. */
    participants?: ActivityParticipant[];
    activityType: ActivityType;
    direction: ActivityDirection | null;
    subject: string;
    description: string | null;
    contactInfo: string | null;
    location: string | null;
    meetingLink: string | null;
    outcome: ActivityOutcome | null;
    activityDate: string;
    durationMinutes: number | null;
    nextFollowUpDate: string | null;
    nextFollowUpNotes: string | null;
    isFollowUpCompleted: boolean;
    createdBy: number;
    createdAt: string;

    // ISO twins of the dates above (BE 2026-10-04). The plain fields are
    // formatted in the SERVER's locale and time zone — parse these instead.
    // Display-only; the BE ignores them on save.
    activityDateIso?: string | null;
    nextFollowUpDateIso?: string | null;
    createdAtIso?: string | null;
    /** Who logged it. */
    createdByName?: string | null;
    /** The record it was logged on ("Acme Ltd", "MR-0042") — on a person's list only. */
    parentLabel?: string | null;

    // Concurrency / idempotency. Optional so legacy code keeps compiling
    // and the BE auto-merge only runs when these are supplied.
    version?: number;
    clientMutationId?: string;
    forceOverwrite?: boolean;
    overwriteReason?: string;
};

// Backward-compatible aliases for Lead module
export const LeadActivityType = ActivityType;
export type LeadActivityType = ActivityType;
export const LeadActivityDirection = ActivityDirection;
export type LeadActivityDirection = ActivityDirection;
export const LeadActivityOutcome = ActivityOutcome;
export type LeadActivityOutcome = ActivityOutcome;
export type LeadActivityItem = ActivityItem;
